import { render, staticRenderFns } from "./defect_items.vue?vue&type=template&id=82c114d8&scoped=true"
import script from "./defect_items.vue?vue&type=script&lang=js"
export * from "./defect_items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c114d8",
  null
  
)

export default component.exports